<template>
  <div class="message-container">
    <div class="message-inner">
      <div v-for="(item, index) in items" :key="index" class="message-box">
        <div class="item-line">
          <em class="fa fa-circle" />
          <div class="line" />
        </div>
        <div class="w-100">
          <div class="row">
            <div class="col-8">
              <div class="item-title">
                <span>{{ item.titleDescription }}</span>
              </div>
            </div>
            <div class="col-4 text-right pr-4">
              <span class="item-hour">
                {{
                  $formatDate(item.createDate, $templateDate.hourWithWeekDay)
                }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col item-content">
              <div class="item-short-description">
                <span>{{ item.messageShortDescription }}</span>
              </div>
              <div class="row">
                <div class="col-6 col-md-6 col-sm-6">
                  <span class="item-read-more" @click="onReadMoreClick(item)">
                    Leer más
                  </span>
                </div>
                <div v-if="item.documentId" class="col-6 col-md-6 col-sm-6">
                  <span
                    class="item-download-file"
                    @click="downloadFile(item.documentId)"
                  >
                    <em class="fa fa-paperclip" />
                    <span>Descargar documento</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasMore" class="row mx-1">
      <div class="col text-center">
        <action-button
          variant="outline-success btn-block p-2"
          @click="$emit('load-more')"
        >
          Ver más
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ActionButton } from '@/components/common';
import alertMixin from '@/mixin/alert.mixin';
import _generalService from '@/services/pei/general';

export default {
  name: 'DashboardMessage',
  mixins: [alertMixin],
  components: {
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    hasMore: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    onReadMoreClick(item) {
      this.ShowAlertModal(item.titleDescription, item.messageDescription, null);
    },
    downloadFile(id) {
      if (id) {
        _generalService.downloadDocumentByAttachmentId(id);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.message-container {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  padding: 20px;
  border-radius: 5px;

  .message-inner {
  }
  .message-box {
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .item-line {
      display: flex;
      flex-direction: column;
      margin-right: 10px;
      margin-left: 5px;
      margin-top: 12px;
      em {
        color: #f8ac40;
        font-size: 7px;
        margin-left: -3px;
        margin-top: 2px;
      }
      .line {
        background: #e7edf3;
        width: 1px;
        height: 100%;
      }
    }

    .item-title {
      background: #d9e5df 0% 0% no-repeat padding-box;
      border-radius: 15px;
      padding: 5px 10px 5px 10px;
      display: inline-block;
      span {
        text-align: left;
        font-size: 14px;
        letter-spacing: 0px;
        color: #11291b;
      }
    }
    .item-hour {
      text-align: right;
      font-size: 13px;
      letter-spacing: 0px;
      color: #828d99;
    }

    .item-content {
      margin: 10px 20px 20px 10px;
      .item-short-description {
        margin-bottom: 10px;
        span {
          text-align: left;
          font-size: 14px;
          letter-spacing: 0px;
          color: #11291b;
        }
      }
      .item-read-more {
        text-align: left;
        text-decoration: underline;
        font-size: 14px;
        letter-spacing: 0px;
        color: #2db782;
        cursor: pointer;
      }
      .item-download-file {
        display: flex;
        text-align: left;
        font-size: 14px;
        letter-spacing: 0px;
        color: #2db782;
        cursor: pointer;
        margin-top: 3px;
        em {
          margin-right: 5px;
          margin-top: 3px;
        }
        span {
          text-decoration: underline;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .message-container {
    border: none;
  }
}
</style>
